/**
 * Time formatting utilities
 */

/**
 * Format time as minutes only
 */
export function formatTime(seconds) {
  if (seconds === 'Unlimited') {
    return 'Unlimited';
  }
  const mins = Math.floor(seconds / 60);
  return `${mins} minute${mins !== 1 ? 's' : ''}`;
}

